import { createContext, useContext } from 'react';

export interface ICarouselState {
  current: number;
  length: number;
  addSlide: (slide: HTMLDivElement) => void;
  removeSlide: (slide: HTMLDivElement) => void;
  pauseSlider: () => void;
  unpauseSlider: () => void;
}

export const CarouselContext = createContext<ICarouselState | undefined>(undefined);

export default function useCarousel() {
  const value = useContext(CarouselContext);
  if (!value) {
    throw new Error('BannerCarouselSlide must be a child of the BannerCarousel component!');
  }
  return value;
}
